iframe = {
	skipExt: ['pdf', 'jpg', 'png', 'zip'],
  
	init() {
	  const selector =
		'a[href]:not([href^="#"], ' +
			this.skipExt.map(ext => `[href$=".${ext}"]`).join(', ') +
		')';
  
		$(document).on('click', selector, e => {
			const url = new URL(e.currentTarget.href, location.href);
			if (url.origin !== location.origin) return;
	
			e.preventDefault();
			$.fancybox.open({
				src : url.pathname + url.search + ' .page__content',
				type: 'ajax'
			});
		});
	}
};



$(document).ready(function() {
	if (IFRAME_PARTNER)
		iframe.init();
});